module.exports = __webpack_public_path__ + "img/free_multiplier_2.d7847fa3.png";